<div class="p-8">
  <app-loading-skeleton class="w-[157px] h-[60px]" viewBox="0 0 157 60">
    <svg:rect x="0" y="0" rx="5" ry="5" width="157" height="60" />
  </app-loading-skeleton>
</div>

<div class="flex">
  <div class="flex">
    @for (skeleton of statusSkeleton; track skeleton) {
      <div class="flex items-center border-l border-stroke-primary-8 pl-[14px] min-w-[100px]">
        <div class="flex flex-col gap-4">
          <app-loading-skeleton class="w-[50px] h-[140px]" viewBox="0 0 50 140">
            <svg:circle cx="26" cy="31" r="20" />
            <svg:rect x="6" y="67" rx="5" ry="5" width="40" height="54" />
          </app-loading-skeleton>
        </div>
      </div>
    }
  </div>
  <div class="w-[250px] relative">
    <app-loading-skeleton
      class="h-[250px] absolute w-full left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
      viewBox="0 0 250 250"
    >
      <svg:circle cx="125" cy="125" r="125" />
    </app-loading-skeleton>
  </div>
</div>
